import { configureStore } from '@reduxjs/toolkit'
import machineReducer from '@/reducers/machine'

export default configureStore({
    reducer: {
        machine: machineReducer,
    },
})